import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

export default function TopEngagementbyStudentGrade({ gradeData }) {


    const RADIAN = Math.PI / 180;
    const COLORS = ['#16A34A', '#1D4ED8', '#FFBB28', '#FF8042'];


    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"
                fontSize={12}
            >
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    return (
        <div className="bg-white rounded-2xl shadow p-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
            {gradeData.map((gradeItem, idx) => (
                <div style={{ width: '50%' }} key={idx}>
                    <ResponsiveContainer width="100%" height={173}>
                        <PieChart>
                            <Pie
                                data={gradeItem.data}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                label={renderCustomizedLabel}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {gradeItem.data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                    <h2 className="text-[15px] text-[#283C50] text-center">
                        Grade {gradeItem.grade}
                    </h2>
                </div>
            ))}
        </div>
    )
}
